import LayoutAdmin from '@/components/layouts/LayoutAdmin';
import LayoutSimple from '@/components/layouts/LayoutSimple';

import AdminAirport from '@/components/AdminAirport';
import AdminAirportStores from '@/components/AdminAirportStores';
import AdminAirportStore from '@/components/AdminAirportStore';

export default {
  path: '/airports',
  component: LayoutAdmin,
  children: [
    {
      path: '',
      redirect: 'new',
    },
    {
      path: 'new',
      name: 'NewAdminAirport',
      component: AdminAirport,
      props: true,
    },
    {
      path: ':id',
      name: 'AdminAirport',
      component: AdminAirport,
      props: true,
    },
    {
      path: ':id/stores',
      component: LayoutSimple,
      props: true,
      children: [
        {
          path: '',
          name: 'AdminAirportStores',
          component: AdminAirportStores,
          props: true,
        },
        {
          path: 'new',
          name: 'NewAdminAirportStore',
          component: AdminAirportStore,
          props: true,
        },
        {
          path: ':storeId',
          name: 'AdminAirportStore',
          component: AdminAirportStore,
          props: true,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/routes.airports.js